import React, { ReactNode, useState, useEffect } from 'react';
import { Button, Input, Textarea, ToastMessage } from '@cokitchen/cokitchen-components';
import Modal from 'react-modal';
import { CloseOutlineIcon } from 'cokitchen-icons';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import Select from 'components/base/select';
import { MealType } from 'utils/types';
import { getBaseMeals } from 'pages/base-items/util';

type DataType = {
  name: string;
  addon_ids: string[];
  amount: string;
  addon_meal_id: string;
};

type EditMealCategoryProps = {
  show: boolean;
  children?: ReactNode;
  onClose: (data?: Record<string, any>) => void;
  data: any;
  multiple?: boolean;
};

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '10px',
    backgroundColor: '#fff',
    border: 'none',
    padding: '0px',
    overflow: 'unset',
    maxWidth: '400px',
    width: '60%'
  },
  overlay: {
    background: 'rgba(0, 0, 0, 0.4)',
    backdropFilter: 'blur(3px)',
    zIndex: 10000
  }
};

const EditAddonModal = ({ show, onClose, data, multiple }: EditMealCategoryProps) => {
  const [formData, setFormData] = useState({} as DataType);
  const [loading, setLoading] = useState(false);
  const [baseMeals, setBaseMeals] = useState([] as MealType[]);

  const fetchBaseMeals = async () => {
    await getBaseMeals(setBaseMeals, true);
  };
  useEffect(() => {
    fetchBaseMeals();
  }, []);
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    if (name === 'amount') {
      const parsedAmount = parseInt(value.replace(/\D/g, ''));
      setFormData({
        ...formData,
        [name]: parsedAmount
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };
  useEffect(() => {
    let ids;
    if (multiple) {
      ids = data?.addon_ids;
    } else {
      ids = [data?.addon_ids];
    }
    setFormData({
      name: data?.name,
      amount: data?.amount,
      addon_ids: ids,
      addon_meal_id: data?.addon_meal_id
    });
  }, [data]);

  const updateMealCategory = async () => {
    setLoading(true);
    formData.amount = formData.amount.toString();

    try {
      const res = await apiService.put(`marketing/addon/bulk`, {
        data: formData
      });
      if (res?.data) {
        toast(<ToastMessage type='success' message='Addons updated successfully' />);
        onClose(formData);
      }
    } catch (err: any) {
      toast(<ToastMessage type='error' message='Error updating addons' />);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      <Modal isOpen={show} style={customStyles} ariaHideApp={false}>
        <div className='pb-8 px-5 space-y-5 text-[#1A1A1A] bg-white rounded-[10px]'>
          <div className='flex justify-between items-center border-b border-solid border-[#EFF0F0] py-4 -mx-[1.2rem] '>
            <div></div>
            <h2 className='font-medium '>Edit Add-on </h2>
            <div className='flex justify-center items-center rounded-full bg-[#EFF0F0] mr-3 w-5 h-5'>
              <CloseOutlineIcon className='cursor-pointer ' onClick={() => onClose()} />
            </div>
          </div>
          <Select
            hasSearch
            //loading={loading}
            value={formData?.addon_meal_id ?? ''}
            options={baseMeals.map((item) => {
              return { value: item.id, text: item.name };
            })}
            placeholder='Select base meal'
            onChange={(v) => setFormData({ ...formData, addon_meal_id: v })}
          />
          <Input
            label='Add-on Name'
            name='name'
            small
            inputClass='h-12 placeholder:text-sm'
            className='text-[14px] '
            placeholder='Rice dishes'
            value={formData.name}
            onChange={handleChange}
          />
          <Textarea
            label='Price'
            name='amount'
            className='h-[100px] text-[14px]'
            placeholder='5,000'
            value={formData.amount || '0'}
            onChange={handleChange}
            typeof='tel'
          />

          <div className='flex justify-center '>
            <Button
              onClick={updateMealCategory}
              loading={loading}
              className=' h-[40px] mt-9'
              color='primary'
              variant='block'>
              Update
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default EditAddonModal;
